/**
 * Menu shell EES — iconKey map sang Ant Design trong Layout.
 * Tab.url: segment ngắn (/list) ghép base parent; fullPath: true = path tuyệt đối.
 */
const menus = [
  {
    title: "Trang chủ",
    iconKey: "home",
    permission_required: "",
    tab: [],
    url: "/dashboard",
    code: "HOME_CONTROLLER"
  },
  {
    title: "Dự án",
    iconKey: "project",
    permission_required: "project.view",
    tab: [
      {
        title: "Danh sách",
        url: "/projects",
        code: "PROJECT_LIST",
        permission_required: "project.view",
        iconKey: "project",
        fullPath: true
      },
      {
        title: "Bản đồ",
        url: "/projects/map",
        code: "PROJECT_MAP",
        permission_required: "project.view",
        iconKey: "home",
        fullPath: true
      }
    ],
    url: "/projects",
    code: "PROJECT_CONTROLLER"
  },
  {
    title: "Vận hành",
    iconKey: "ops",
    permission_required: "daily_log.view",
    tab: [
      {
        title: "Nhật ký ngày",
        url: "/daily-logs",
        code: "DAILY_LOG",
        permission_required: "daily_log.view",
        iconKey: "daily"
      },
      {
        title: "Chất lượng nước",
        url: "/water-results",
        code: "WATER",
        permission_required: "water_result.view",
        iconKey: "water"
      }
    ],
    url: "/daily-logs",
    code: "OPS_CONTROLLER"
  },
  {
    title: "Thiết bị · Kho",
    iconKey: "asset",
    permission_required: "",
    tab: [
      {
        title: "Tổng quan",
        url: "/amm",
        code: "AMM_OVERVIEW",
        permission_required: "amm.dashboard.view",
        iconKey: "home",
        fullPath: true
      },
      {
        title: "Thiết bị",
        url: "/amm/thiet-bi",
        code: "AMM_EQUIPMENT",
        permission_required: "amm.equipment.view",
        iconKey: "equipment",
        fullPath: true
      },
      {
        title: "Kho công ty",
        url: "/amm/kho",
        code: "AMM_STOCK",
        permission_required: "amm.stock.view",
        iconKey: "catalog",
        fullPath: true
      },
      {
        title: "Kho dự án",
        url: "/amm/kho-du-an",
        code: "AMM_PROJECT_STOCK",
        permission_required: "amm.stock.view",
        iconKey: "project",
        fullPath: true
      },
      {
        title: "Kiểm kê",
        url: "/amm/kiem-ke",
        code: "AMM_STOCKTAKE",
        permission_required: "amm.stock.view",
        iconKey: "ops",
        fullPath: true
      },
      {
        title: "Cấp phát",
        url: "/amm/cap-phat",
        code: "AMM_ISSUE",
        permission_required: "amm.request.view",
        iconKey: "ops",
        fullPath: true
      },
      {
        title: "Bảo trì",
        url: "/amm/bao-tri",
        code: "AMM_MAINT",
        permission_required: "amm.wo.view",
        iconKey: "daily",
        fullPath: true
      },
      {
        title: "Danh mục & cài đặt",
        url: "/amm/cai-dat",
        code: "AMM_SETTINGS",
        permission_required: "amm.catalog.view",
        iconKey: "settings",
        fullPath: true
      },
      {
        title: "Báo cáo TB",
        url: "/amm/bao-cao",
        code: "AMM_REPORTS",
        permission_required: "amm.reports.view",
        iconKey: "report",
        fullPath: true
      }
    ],
    url: "/amm",
    code: "AMM_CONTROLLER"
  },
  {
    title: "Giám sát",
    iconKey: "alert",
    permission_required: "",
    tab: [
      {
        title: "Cảnh báo",
        url: "/alerts",
        code: "ALERT_CONTROLLER",
        permission_required: "alert.view",
        iconKey: "alert",
        fullPath: true
      },
      {
        title: "Kết nối telemetry",
        url: "/telemetry",
        code: "TELEMETRY_CONTROLLER",
        permission_required: "telemetry.view",
        iconKey: "ops",
        fullPath: true
      },
      {
        title: "Sự cố",
        url: "/incidents",
        code: "INCIDENT_CONTROLLER",
        permission_required: "incident.view",
        iconKey: "incident",
        fullPath: true
      }
    ],
    url: "/alerts",
    code: "MONITOR_CONTROLLER"
  },
  {
    title: "Báo cáo",
    iconKey: "report",
    permission_required: "report.view",
    tab: [],
    url: "/reports",
    code: "REPORT_CONTROLLER"
  },
  {
    title: "Doanh thu O&M",
    iconKey: "report",
    permission_required: "revenue.view",
    tab: [],
    url: "/revenue",
    code: "REVENUE_CONTROLLER"
  },
  {
    title: "Cài đặt",
    iconKey: "settings",
    permission_required: "",
    tab: [
      {
        title: "Danh mục dùng chung",
        url: "/settings/catalogs",
        code: "MASTER_CATALOG",
        permission_required: "catalog.manage",
        iconKey: "catalog",
        fullPath: true
      },
      {
        title: "Quy chuẩn QCVN",
        url: "/settings/compliance",
        code: "COMPLIANCE_CFG",
        permission_required: "compliance.manage",
        iconKey: "compliance",
        fullPath: true
      }
    ],
    url: "/settings/catalogs",
    code: "SETTINGS_CONTROLLER"
  },
  {
    title: "Quản trị",
    iconKey: "staff",
    permission_required: "",
    tab: [
      {
        title: "Người dùng",
        url: "/list",
        code: "STAFF_CONTROLLER",
        permission_required: "user.view",
        iconKey: "user"
      },
      {
        title: "Nhóm / Role",
        url: "/groups",
        code: "GROUP_CONTROLLER",
        permission_required: "role.view",
        iconKey: "role"
      },
      {
        title: "Nhật ký thao tác",
        url: "/audit-logs",
        code: "AUDIT_CONTROLLER",
        permission_required: "audit.view",
        iconKey: "staff",
        fullPath: true
      }
    ],
    url: "/staff/list",
    code: "STAFF_CONTROLLER"
  }
]

export default menus
